import React from 'react';
import './Questions.css';

const Questions = () => {
  return (
    <div className="questions-container">
      <h1>Interview Questions</h1>
      <section>
        <h2>Behavioral Questions</h2>
        <p>Our behavioral questions are designed to assess your past experiences and how you've handled various situations. These questions help evaluate your problem-solving skills, leadership abilities, and how you work in a team.</p>
      </section>
      <section>
        <h2>Technical Questions</h2>
        <p>Our technical questions cover three main areas:</p>
        <ul>
          <li><strong>Product Design:</strong> These questions assess your ability to conceptualize and design products.</li>
          <li><strong>Market Sizing:</strong> These questions evaluate your analytical skills and ability to make estimations.</li>
          <li><strong>Metrics:</strong> These questions test your understanding of key performance indicators and how to measure product success.</li>
        </ul>
      </section>
      <p>Our AI-powered system selects questions based on your choices and adapts to your responses, providing a tailored interview experience.</p>
    </div>
  );
};

export default Questions;